export default function searchhandler() {
	const searchArray = Array.from(
		document.querySelectorAll('.search-expandable'),
	);
	const searchButtonArray = Array.from(
		document.querySelectorAll('.search-expandable__icon'),
	);
	const closeBtn = Array.from(
		document.querySelectorAll('.search-expandable__close'),
	);

	// searchButton.addEventListener('click', function () {
	//   console.log('click');
	//   // searchArray.forEach(function (search) {
	//   //   search.classList.toggle('search__open');
	//   // })
	// })

	searchButtonArray.forEach(function (searchButton) {
		searchButton.addEventListener('click', function () {
			//  console.log('click');
			searchArray.forEach(function (search) {
				search.classList.toggle('search__open');
			});
		});
	});

	closeBtn.forEach(function (searchOverlay) {
		searchOverlay.addEventListener('click', function () {
			searchArray.forEach(function (search) {
				search.classList.remove('search__open');
			});
		});
	});
}
